import { INextStepAction, IState, Step } from '../../../types/state';

export const nextStep = (state: IState, _action: INextStepAction): IState => ({
    ...state,
    step: Step.SelectContentGuidelines,
  });
